export default class NotifyMe {
  init() {
    this.handleResponse();
    this.resetQuantityState();
    this.checkQuantityOnBlur();
    this.validateEmailOnBlur();
    this.submit();
  }

  handleResponse() {
    $('body').on('product:updateAddToCart', function (e, response) {
      const stockNotificationEnable = response.product.productCTA.notifyMeAvailability;
      const addToCart = 'button.add-to-cart, .add-to-cart-global';
      const notify = '.notifyme-button-container';
      const details = '.details-bottom';
      const sticky = '.sticky-container';

      if (Object.prototype.hasOwnProperty.call(response.product, 'productCTA')) {
        if (stockNotificationEnable) {
          $(addToCart, details).addClass('d-none');
          $(notify, details).removeClass('d-none');
          $(addToCart, sticky).addClass('d-none');
          $(notify, sticky).removeClass('d-none');
        } else {
          $(addToCart, details).removeClass('d-none');
          $(notify, details).addClass('d-none');
          $(addToCart, sticky).removeClass('d-none');
          $(notify, sticky).addClass('d-none');
        }
      }
    });
  }

  /**
   * Returns true if the email contains a forbidden substring, false otherwise.
   * @param {string} email
   * @param {string[]} forbiddenList - array of forbidden substrings (already lowercased)
   * @returns {boolean}
   */
  static isForbiddenEmail(email, forbiddenList) {
    if (!forbiddenList || forbiddenList.length === 0) return false;
    const lowerEmail = email.toLowerCase();
    return forbiddenList.some((forbidden) => lowerEmail.indexOf(forbidden) !== -1);
  }

  /**
   * Validates the email field against the forbidden list and updates its UI state.
   * @param {jQuery} $form - The .notifyme-form element
   * @returns {boolean} true if the email is valid (not forbidden)
   */
  static runEmailForbiddenCheck($form) {
    const $field = $form.find('#email');
    const $feedback = $form.find('#emailHelp');

    // data-forbidden-emails is a comma-separated string (e.g. "@yopmail.com,tempmail").
    const raw = $form.data('forbidden-emails');
    let forbiddenList = [];
    if (raw) {
      forbiddenList = String(raw)
        .split(',')
        .map((s) => s.trim().toLowerCase())
        .filter(Boolean);
    }

    if (NotifyMe.isForbiddenEmail($field.val(), forbiddenList)) {
      $field.addClass('is-invalid');
      $feedback.text($form.data('forbidden-email-msg'));
      return false;
    }

    $field.removeClass('is-invalid');
    $feedback.text('');
    return true;
  }

  /**
   * Calls NotifyMe-CheckQuantity and updates the quantity field validity state.
   *
   * @param {jQuery} $form - The .notifyme-form element
   * @param {Function} onComplete - Called with (isValid: boolean) after the check completes
   */
  static runQuantityCheck($form, onComplete) {
    const $field = $form.find('#quantityRequested');
    const $submitBtn = $form.find('[type="submit"]');
    const $feedback = $form.find('#quantityReq');
    const checkUrl = $form.data('check-quantity-url');
    const productID = $form.find('[name="productID"]').val();
    const quantityRequested = parseInt($field.val(), 10);

    if (!checkUrl || !productID || !quantityRequested || quantityRequested <= 0) {
      if (onComplete) onComplete(true);
      return;
    }

    $.ajax({
      url: checkUrl,
      type: 'GET',
      dataType: 'json',
      data: { productID: productID, quantityRequested: quantityRequested },
      success: function (data) {
        if (data.alreadyAvailable) {
          $field.addClass('is-invalid');
          $feedback.text(data.msg);
          $submitBtn.prop('disabled', true);
          if (onComplete) onComplete(false);
        } else {
          $field.removeClass('is-invalid');
          $feedback.text('');
          $submitBtn.prop('disabled', false);
          if (onComplete) onComplete(true);
        }
      },
      error: function () {
        // On network error fail open: do not block the user
        $field.removeClass('is-invalid');
        $feedback.text('');
        $submitBtn.prop('disabled', false);
        if (onComplete) onComplete(true);
      }
    });
  }

  resetQuantityState() {
    $('body').on('show.bs.modal', '.notifyme-modal', function () {
      const $form = $(this).find('.notifyme-form');
      $form.find('#quantityRequested').removeClass('is-invalid');
      $form.find('#quantityReq').text('');
      $form.find('[type="submit"]').prop('disabled', false);
    });
  }

  validateEmailOnBlur() {
    $('body').on('blur', '.notifyme-form #email', function () {
      const $form = $(this).closest('.notifyme-form');
      NotifyMe.runEmailForbiddenCheck($form);
    });
  }

  checkQuantityOnBlur() {
    $('body').on('blur', '.notifyme-form #quantityRequested', function () {
      const $form = $(this).closest('.notifyme-form');
      NotifyMe.runQuantityCheck($form, null);
    });
  }

  submit() {
    $('body').on('submit', '.notifyme-form', function (e) {
      e.preventDefault();
      const form = $(this);
      const error = form.attr('data-unsuccess-msg');

      // Validate forbidden email before anything else.
      if (!NotifyMe.runEmailForbiddenCheck(form)) {
        return;
      }

      // Always re-validate quantity before submitting (covers pre-filled values
      // where the user never triggered blur).
      NotifyMe.runQuantityCheck(form, function (isValid) {
        if (!isValid) {
          return;
        }

        form.find('.btn-loader').spinner().start();

        $.ajax({
          url: form.attr('action'),
          type: 'POST',
          dataType: 'json',
          data: form.serialize(),
          success: function (data) {
            form.remove();
            $('#notifyme-title').html(data.title);
            $('#notifyme-description').html(data.msg).addClass('alert alert-info mt-3 mb-4');
            $('body').trigger('notifyme:success');
          },
          error: function () {
            form.remove();
            $('#notifyme-description').html(error).addClass('alert alert-danger mt-3 mb-4');
            $('body').trigger('notifyme:error');
          }
        });
      });
    });
  }
}
